import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "antd";
import { DeploymentUnitOutlined } from "@ant-design/icons";
import ReportDom from "../../../components/common/ReportDom";
import ErrorBoundary from "../../../components/common/ErrorBoundary";
import SalesVoucherBody from "./SalesVoucherBody";
import SalesVoucherBodyDesignA from "./SalesVoucherBodyDesignA";
import WorkflowDrawer from "../../Workflow/WorkflowDrawer";
import { fetchSingleInstitutionDetails } from "../../../store/commonThunks/lookups";

export default function PrintSalesVoucher() {
  const { sale_id } = useParams();
  const [ready, setReady] = useState(false);
  const [wfOpen, setWfOpen] = useState(false);
  const dispatch = useDispatch();
  const { institutionData } = useSelector((state) => state.lookups);
  const isDesignA = institutionData?.print_template === "design_a";

  useEffect(() => {
    // This route is opened as a standalone page (a fresh tab/page load, not
    // client-side navigation from an already-loaded screen), so the Redux
    // store starts empty -- institutionData.print_template would otherwise
    // never load here, silently falling back to the legacy layout even when
    // Design A is selected. Fetch it here instead of assuming some other
    // page already did.
    dispatch(fetchSingleInstitutionDetails()).finally(() => setReady(true));
  }, [dispatch]);

  if (!ready) return null;

  return (
    <div style={{ background: "#fff", padding: 0 }}>
      {/* Workflow action — hidden when printing */}
      <style>{`@media print { .wf-no-print { display: none !important; } }`}</style>
      <div className="wf-no-print" style={{ display: "flex", justifyContent: "flex-end", padding: "8px 16px" }}>
        <Button type="primary" ghost icon={<DeploymentUnitOutlined />} onClick={() => setWfOpen(true)}>
          Workflow
        </Button>
      </div>

      <ErrorBoundary message="This invoice could not be loaded.">
        {isDesignA ? (
          // Design A builds its own full header/footer (navy band, page
          // numbers, etc.) -- mode="no-title" suppresses ReportDom's generic
          // InstitutionProfile header and Notes/Signature footer so there's
          // only ever one of each on the page.
          <ReportDom mode="no-title" renderTable={() => <SalesVoucherBodyDesignA sale_id={sale_id} />} />
        ) : (
          <ReportDom
            renderTable={() => (
              <SalesVoucherBody
                sale_id={sale_id}
                printMode
                showStamp
                showSignature
              />
            )}
          />
        )}
      </ErrorBoundary>

      <WorkflowDrawer
        recordType="sales"
        recordId={sale_id}
        open={wfOpen}
        onClose={() => setWfOpen(false)}
        title={`Workflow — Invoice ${String(sale_id || "").slice(0, 8)}…`}
      />
    </div>
  );
}
